import { render, staticRenderFns } from "./RestaurantHighlights.vue?vue&type=template&id=ab566d0a&"
import script from "./RestaurantHighlights.vue?vue&type=script&lang=js&"
export * from "./RestaurantHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports